import { render, staticRenderFns } from "./depo-transit-list.vue?vue&type=template&id=37b0bbdc&scoped=true"
import script from "./depo-transit-list.vue?vue&type=script&lang=ts"
export * from "./depo-transit-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b0bbdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b0bbdc')) {
      api.createRecord('37b0bbdc', component.options)
    } else {
      api.reload('37b0bbdc', component.options)
    }
    module.hot.accept("./depo-transit-list.vue?vue&type=template&id=37b0bbdc&scoped=true", function () {
      api.rerender('37b0bbdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders-dispatches/depo-transit-list.vue"
export default component.exports